import React from 'react';

const ClickOutSideContext = React.createContext({
  onClickOutSide: undefined
});

export default ClickOutSideContext;
